import { useTranslate } from "#src/hooks";
import { StepHeader } from "../MobileCloning/StepHeader";
import { ClonedFacePreview } from "./ClonedFacePreview";
import { ClonedPreviewCard } from "./ClonedPreviewCard";

export const FaceCloningConfirm = ({
  capturedPhotoUrl,
}: {
  capturedPhotoUrl: string;
}) => {
  const t = useTranslate();
  return (
    <>
      <StepHeader
        title={t("src.components.ContactCloningMobile.camera.photoCaptured")}
        description={t(
          "src.components.ContactCloningMobile.camera.description"
        )}
      />
      <ClonedPreviewCard style={{ aspectRatio: 1 }}>
        <ClonedFacePreview faceUrl={capturedPhotoUrl} />
      </ClonedPreviewCard>
    </>
  );
};
